// OLD: import React, { useState, useEffect } from 'react';
import React, { useState } from 'react';
import { TableComponent, SortingColumnsType, } from "../../../components/table-component/table"
import { AnalyticsService, ApplyCampaignService, LocalService } from '../../../core/services';
import { FormValidation } from "../../../core/utility";
// OLD: import { TextField, Select, OutlinedInput, MenuItem, InputLabel, FormControl } from '@mui/material';
import { TextField } from '@mui/material';
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import { BASE_URL_WEB } from "../../../config/config";
import CommonPopUp from '../../../components/popup/common-popup';
// OLD: import { MenuPropsSelect } from '../../../core/utility/style'; (influencer dropdown)
import { NavLink } from 'react-router-dom';
import * as gtUtil from "../../../core/utility";
import ExcelPostLinksUpload, { ExcelPostLinkRow } from './excel-post-links-upload';
const localService = new LocalService();
const analyticsService = new AnalyticsService();

const applyCampaignService = new ApplyCampaignService();
// OLD: const columnDisplayName = {
//   influencerName: "Influencer Name",
//   postLink: "Post Link",
// };
// The influencer is no longer picked here - the analytics service links the post to the campaign
// influencer who posted it (Instagram username / YouTube channel) when it fetches the post.
const columnDisplayName = {
  postLink: "Post Link",
};
interface ErrorTypes {
  status: boolean;
  message: string;
}
const sortingColumnType: SortingColumnsType[] = [
  // OLD: {
  //   name: "influencerName",
  //   columnSize: ".875rem",
  // },
  {
    name: "postLink",
    columnSize: "1rem",
  },
  {
    name: "",
    columnSize: ".3125rem",
  },
];

interface Influencer {
  sm_id: number | string;
  name: string;
}

interface FormData {
  postLink: string;
  influencer: Influencer;
}

interface AddAnalyticsBrandProps {
  open: boolean;
  campaign_id: number;
  onClose: () => void;
  post_platform: string,
  sm_id: number;
  totalPost?:any;
  getSubscriptionDetail?:any;
  handleOpenUpgradeBrandModal?:((value:boolean) => void) | undefined;
  campaignType:string;
  onUpdatePostLinks?:any;
  account_type?: string;
}

const AddAnalyticsBrand: React.FC<AddAnalyticsBrandProps> = ({ open, onClose, campaign_id, post_platform, sm_id, getSubscriptionDetail, totalPost, handleOpenUpgradeBrandModal, campaignType, onUpdatePostLinks, account_type}) => {
  const formValidation = new FormValidation();
  const [postLink, setPostLink] = useState('');
  const [influencer, setInfluencer] = useState<Influencer>({sm_id: 0, name: "Other Influencer"});
  const [formDataList, setFormDataList] = useState<FormData[]>([]);
  const [errorPostLink, setErrorPostLink] = useState<ErrorTypes>();
  // OLD: const [influencerList, setInfluencerList] = useState<string[]>([]); (influencer dropdown)
  const [previousLinks, setPreviousLinks] = useState<string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [popupMessage, setPopupMessage] = useState<string>('');
  // Pagination for the staged links table (Excel can add hundreds). Done here, not via
  // TableComponent's `pagination` prop - that writes only the current page back into
  // setRenderData, which is formDataList here, so the other pages would be lost before Submit.
  const [stagedPage, setStagedPage] = useState(0);
  const [stagedRowsPerPage, setStagedRowsPerPage] = useState(10);
  const stagedPageCount = Math.max(1, Math.ceil(formDataList.length / stagedRowsPerPage));
  const safeStagedPage = Math.min(stagedPage, stagedPageCount - 1);
  const stagedOffset = safeStagedPage * stagedRowsPerPage;

  const closeModal = async () => {
    setOpenModal(false);
    setErrorPostLink({status: true, message: ""});
  }

  // OLD: approved influencers for the "Select influencer" dropdown - no longer needed (auto-linked by the service)
  // useEffect(() => {
  //   getApprovedInfluencerList();
  // }, []);

  const handleSubmit = async () => {
    // let is_duplicate_link = false
    let is_valid_link =false
    const campaignId = campaign_id
    const res = await analyticsService.getAnalyticsLinks(campaignId)

    // instagram.com/<username>/reel/<code> -> instagram.com/reel/<code>/ (validates + de-dupes like a copied link)
    // OLD: (used postLink as typed)
    const link = post_platform == "Instagram" ? formValidation.normalizeInstagramPostUrl(postLink) : postLink.trim();
    if (link !== postLink) setPostLink(link);

    if(post_platform == "Instagram"){
      setErrorPostLink(formValidation.CheckInstagramUrl(link));
      is_valid_link = formValidation.CheckInstagramUrl(link).status
    }
    else
    {
      setErrorPostLink(formValidation.CheckYouTubeUrl(link));
      is_valid_link = formValidation.CheckYouTubeUrl(link).status
    }

    // Check if postLink already exists in the response data
    // is_duplicate_link = (res.data.rows).some((item:any) => item.post_url === postLink);
    // OLD: const isIncluded = (res.data.rows).some((item:any) => (item.post_url.includes(postLink) || postLink.includes(item.post_url)));
    // Ignore rows with a blank post_url - `postLink.includes('')` is always true, so they made every link a "duplicate".
    const isIncluded = (res.data.rows).some((item:any) => {
      const existing = (item?.post_url || '').trim();
      return !!existing && (existing.includes(link) || link.includes(existing));
    });
    
    if (isIncluded) {
      setErrorPostLink({ status: false, message: 'This link has already been added.' });
      return; 
    }
    if(is_valid_link){
      if(getSubscriptionDetail.isBasicUser && campaignType === 'Paid'){
        if((formDataList.length + totalPost) < (getSubscriptionDetail.add_post_link_limit)){
          setPreviousLinks([...previousLinks, link])
          const formData: FormData = { influencer, postLink: link };
          setFormDataList([...formDataList, formData]);
          setPostLink('');
          setInfluencer({sm_id: 0, name: "Other Influencer"});
        }else{
          if(handleOpenUpgradeBrandModal){
            // handleOpenUpgradeBrandModal(true)
            setOpenModal(true)
            setPopupMessage('You can add only 1 link for this FOC campaign. To add more, please upgrade.')
          }
        }
      }else if (getSubscriptionDetail.isBasicUser && campaignType === 'Barter'){
        if((formDataList.length + totalPost) < (getSubscriptionDetail.barter_add_post_link_limit)){
          setPreviousLinks([...previousLinks, link])
          const formData: FormData = { influencer, postLink: link };
          setFormDataList([...formDataList, formData]);
          setPostLink('');
          setInfluencer({sm_id: 0, name: "Other Influencer"});
        }else{
          if(handleOpenUpgradeBrandModal){
            setOpenModal(true)
            setPopupMessage('A maximum of 10 links can be added for this Barter campaign. To add more, please upgrade or')
          }
        }
      }
      // else if (getSubscriptionDetail.isBasicUser == false && getSubscriptionDetail.amount == 2500){
      //   if((formDataList.length + totalPost) < 40){
      //     const formData: FormData = { influencer, postLink };
      //     setFormDataList([...formDataList, formData]);
      //     setPostLink('');
      //     setInfluencer({sm_id: 0, name: "Other Influencer"});
      //     }else{
      //       if(handleOpenUpgradeBrandModal){
      //         setOpenModal(true)
      //         setPopupMessage("You can add up to 30 links. You've reached the maximum limit. To add more links, please contact us.")
      //       }
      //     }
      // }
      else{
        setPreviousLinks([...previousLinks, link])
        const formData: FormData = { influencer, postLink: link };
        setFormDataList([...formDataList, formData]);
        setPostLink('');
        setInfluencer({sm_id: 0, name: "Other Influencer"});
      }
    }
     
  };

  // ---- Excel bulk add -------------------------------------------------------
  // Remaining links the plan allows (Basic plans only, same rule as the single add); undefined = no limit.
  const excelMaxRows: number | undefined =
    getSubscriptionDetail?.isBasicUser && campaignType === 'Paid'
      ? getSubscriptionDetail.add_post_link_limit - (formDataList.length + (totalPost || 0))
      : getSubscriptionDetail?.isBasicUser && campaignType === 'Barter'
        ? getSubscriptionDetail.barter_add_post_link_limit - (formDataList.length + (totalPost || 0))
        : undefined;

  const handleExcelLimitReached = () => {
    if (!handleOpenUpgradeBrandModal) return;
    setOpenModal(true);
    setPopupMessage(
      campaignType === 'Barter'
        ? 'A maximum of 10 links can be added for this Barter campaign. To add more, please upgrade or'
        : 'You can add only 1 link for this FOC campaign. To add more, please upgrade.'
    );
  };

  const handleExcelRows = (rows: ExcelPostLinkRow[]) => {
    setFormDataList((prev) => [...prev, ...rows]);
    setPreviousLinks((prev) => [...prev, ...rows.map((r) => r.postLink)]);
  };

  const removeItem = (index: number) => {
    const removedLink = formDataList[index]?.postLink;
    const updatedFormDataList = formDataList.filter((_, i) => i !== index);
    setFormDataList(updatedFormDataList);
    // OLD: const newLinkArray = previousLinks.filter((_, i) => i !== index);
    // Remove by value - sorting the table reorders formDataList but not previousLinks.
    const linkIndex = previousLinks.indexOf(removedLink);
    const newLinkArray = previousLinks.filter((_, i) => i !== linkIndex);
    setPreviousLinks(newLinkArray);
    localService.toastify("Post link deleted successfully!");
  };


  const handleSubmitUserForm = async () => {
    const res = await applyCampaignService.uploadPostLinkAnalytics({
      data: {
        campaign_id: campaign_id,
        post_platform: post_platform,
        formDataList: formDataList,
        sm_id: sm_id,
        account_type: account_type
      },
    });
    if (res) {
      if (res.status == gtUtil.Constants.SUCCESS) {
        localService.toastify(res?.info);
        onClose()
         // Call the parent's function to update post links
          await onUpdatePostLinks();
      }
      else {
        setOpenModal(true)
        setPopupMessage(res?.info)
        // localService.toastify(res?.data?.status?.message);
      }
    }
  };

  const handlePostLinkChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const url = event?.target?.value;
    const post_link = previousLinks;
    const isIncluded = (post_link as string[]).some(link => (link.includes(url) || url.includes(link)));
    setPostLink(url);
    if (url == '') {
      setErrorPostLink({status: false, message: "This field is required."});
    }
    else if (isIncluded) {
      setErrorPostLink({ status: false, message: "This link is already added" });
    } else {
      // setPreviousLinks([...previousLinks, url]);
      setErrorPostLink({status: true, message: ""});
    }
  }

  // OLD: influencer dropdown data - no longer needed (auto-linked by the analytics service)
  // const getApprovedInfluencerList = async () => {
  //   const res = await ApplyCampaignService.influencerList({
  //     campaign_id: campaign_id,
  //     proposalStatus: 'Accepted',
  //   })

  //   if (res) {
  //     setInfluencerList(res.data.rows)
  //   }

  // }

  return (
    <>
      <CommonPopUp
        modalTitle={`Add ${post_platform} post`}
        openModal={open}
        onClose={onClose}
        className="modal-medium popup-add-post-link"
      >
        <div className='add-post-link-sec d-flex align-items-start row mt-3 pb-3'>
          {/* OLD: "Select influencer" dropdown - the influencer is now detected from the post itself
          <div className="col-12 col-md-3 mb-3 mb-md-0">
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-name-label">Select influencer</InputLabel>
            <Select
              value={JSON.stringify(influencer)}
              onChange={(event: any) => {
                const obj = JSON.parse(event?.target?.value);
                setInfluencer(obj);
              }}
              input={<OutlinedInput label="Select an influencer" />}
              MenuProps={MenuPropsSelect}
            >
              {influencerList ? (
                influencerList.map((res: any) => (
                  <MenuItem
                    key={post_platform === "Instagram" ? res.ig_id : res.yt_id}
                    value={JSON.stringify({
                      sm_id: post_platform === "Instagram" ? res.ig_id : res.yt_id,
                      name: post_platform === "Instagram" ? res.insta_name : res.title,
                    })}
                  >
                    {post_platform === "Instagram" ? res.insta_name : res.title}
                  </MenuItem>
                ))
              ) : <MenuItem
              key={1}
              value={1}
            >
              {"No Data"}
            </MenuItem>}
              <MenuItem value={JSON.stringify({
                sm_id: 0,
                name: "Other Influencer",
              })}>Other Influencer</MenuItem>
            </Select>
          </FormControl>
          </div>
          */}
          <div className="col-12 col-md mb-3 mb-md-0">
            <TextField
              label="Post Link"
              value={postLink}
              className="w-100 mt-0 add-post-link-url"
              onChange={handlePostLinkChange}

              size="small"
              fullWidth
              margin="normal"
            />
            <span className="error">{errorPostLink?.message}</span>
            {!errorPostLink?.message && (
              <span className="d-block mt-1" style={{ color: '#64748b', fontSize: 12 }}>
                The influencer is detected automatically from the post.
              </span>
            )}
          </div>
          <div className={"col-12 col-md-auto" + (!errorPostLink?.status ? " btn-disabled-new" : "")}>
            <button
              onClick={handleSubmit}
              className="btn btn-outline-primary">
               Add Post
            </button>
          </div>
        </div>
        <ExcelPostLinksUpload
          campaignId={campaign_id}
          platform={post_platform}
          // OLD: influencerList={influencerList as any[]}
          withInfluencer={false} // template has only the Post Link column - influencer is auto-detected
          stagedLinks={previousLinks}
          maxRows={excelMaxRows}
          onLimitReached={handleExcelLimitReached}
          onRows={handleExcelRows}
        />
        {
          (() => {
            if (formDataList.length > 0) {
              return (
                <>
                  <TableComponent
                    columnDisplayName={columnDisplayName}
                    orderByColumnName=""
                    inputDataSource={formDataList}
                    sortingColumnType={sortingColumnType}
                    renderData={formDataList}
                    setRenderData={(e) => setFormDataList(e)}
                  >
                    {/* OLD: {formDataList.map((data: FormData, index: number) => { */}
                    {formDataList.slice(stagedOffset, stagedOffset + stagedRowsPerPage).map((data: FormData, pageIndex: number) => {
                      const index = stagedOffset + pageIndex; // index in the full list (used by removeItem)
                      return (
                        <TableRow key={index} hover role="checkbox">
                          {/* OLD: Influencer Name cell - removed with the dropdown
                          <TableCell>
                            {
                              (()=>{
                                return data.influencer.name
                                // if(data.influencer.name == "Other Influencer"){
                                //   return data.influencer.name
                                // }
                                // else{
                                //   influencerList
                                //   .filter((item: any) => {
                                //     if (post_platform === "Instagram") {
                                //       return item.ig_id === data?.influencer;
                                //     } else {
                                //       return item.yt_id === data?.influencer;
                                //     }
                                //   })
                                //   .map((filteredItem: any) => {
                                //     return post_platform === "Instagram" ? (filteredItem.username !== null ? filteredItem.username : "Other Influencer"): (filteredItem.title !== null ? filteredItem.title : "Other Influencer");
                                //   })}
                              })()
                            }
                          </TableCell>
                          */}
                          <TableCell style={{maxWidth:'450px'}}>{data?.postLink}</TableCell>
                          <TableCell>
                            <span style={{ cursor: 'pointer' }}
                              onClick={(e) => removeItem(index)} className='material-symbols-rounded'>
                              delete
                            </span>
                          </TableCell>
                        </TableRow>
                      );
                    })}

                  </TableComponent>
                  {formDataList.length > 10 && (
                    <TablePagination
                      className='common-pagination'
                      component="div"
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      count={formDataList.length}
                      page={safeStagedPage}
                      rowsPerPage={stagedRowsPerPage}
                      onPageChange={(_e, newPage) => setStagedPage(newPage)}
                      onRowsPerPageChange={(e) => {
                        setStagedRowsPerPage(parseInt(e.target.value, 10));
                        setStagedPage(0);
                      }}
                      sx={{ color: "#00aae5" }}
                    />
                  )}
                  <div className='d-flex justify-content-end'>
                    <button className='my-3 btn btn-primary' onClick={handleSubmitUserForm}>Submit{formDataList.length > 1 ? ` (${formDataList.length})` : ''}</button>
                  </div>
                </>
              )
            }
          })()
        }
      </CommonPopUp>
      {openModal && (
        <CommonPopUp
          modalTitle={popupMessage.includes('30') ? "" : "Upgrade to Premium:"}
          modalContent=""
          openModal={openModal}
          onClose={closeModal}
          className="modal-medium mx-auto"
        >
          <div className="">
            {/* <div>
              <p>{popupMessage}</p>
            </div> */}

            <div>
              <p>
                {popupMessage}
                {popupMessage.includes('Barter') && (
                  <a className="ms-2" href={`${BASE_URL_WEB}/contact_us`}>
                    contact us
                  </a>
                )}
              </p>
            </div>

            <div className='popup-footer' style={{ marginTop: "32px" }}>
              <div className='row'>
                <div className='col text-end'>
                  {popupMessage.includes('30') ? (
                    <a className="btn btn-primary ms-2 btn-mui" href={`${BASE_URL_WEB}/contact_us`}>
                      Contact us
                    </a>
                  ) : (
                    <a className="btn btn-primary ms-2 btn-mui" href="/brand/settings/subscription">
                      Upgrade Now
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </CommonPopUp>
      )}
    </>
  );
};

export default AddAnalyticsBrand;